module.exports = __webpack_public_path__ + "static/track-finance-0d77bb278ac95cd3d984dcace7b21412.svg";